module.exports = RedNaoFormBuilder.default('FormBuilder/Core/FormBuilder.options');